export default __webpack_public_path__ + "static/media/banner-bust.53fbbcc8.png";